<bdcp-products-search-bar></bdcp-products-search-bar>

<div class="container">
  <div class="top">
    <div *ngIf="alternativeMode" (click)="back()" class="back">
      <i class="fa fa-chevron-left"></i>
      Zurück zur Ergebnisliste
    </div>
    <div class="header">
      <div class="title">
        <div *ngIf="!alternativeMode" class="main">Produktfinder:&nbsp;</div>
        <div *ngIf="alternativeMode" class="main">Vergleichsprodukte:&nbsp;</div>
        <div class="sub">{{products.length}} Ergebnis{{products.length === 1 ? '' : 'se'}}</div>
      </div>
      <div class="nav">
        <div class="buttons">
          <ng-select *ngIf="isBrotherResult" [(ngModel)]="order" (ngModelChange)="orderChanged()" [searchable]="false"
            [clearable]="false" placeholder="Sortieren">
            <ng-option value="asc">Nach Artikelnummer aufsteigend</ng-option>
            <ng-option value="desc">Nach Artikelnummer absteigend</ng-option>
          </ng-select>
          <div *ngIf="alternativeMode"></div>
          <button (click)="navigateToCategorySelection()">{{!isBrotherResult ? 'Alle Brother-Produkte' : 'Alle Produkte'}}</button>
        </div>
      </div>
      <div *ngIf="!alternativeMode" class="filters">
        <div *ngFor="let filter of filters" class="filter">
          {{filter}}
        </div>
      </div>
      <div *ngIf="alternativeMode" class="filters"></div>
    </div>
  </div>
  <bd-hr></bd-hr>
  <div *ngIf="alternativeMode" class="alternatives-header">
    <div class="change-product">
      Nicht das richtige Produkt?
      <button (click)="back()" class="bd-red-button-reversed">
        Produkt ändern&nbsp;
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
    <div class="product-overview">
      <div class="image">
        <img [src]="alternativeBaseProduct?.imageUrl" (error)="onImageError($event)" />
      </div>
      <div class="informations">
        <div class="sub-info">
          Ihr ausgewähltes Vergleichsprodukt:
        </div>
        <div class="name">
          {{alternativeBaseProduct.productModel}}
        </div>
        <div class="manufacturer">
          {{alternativeBaseProduct.manufacturerName}} / {{alternativeBaseProduct.productTypeName}}
        </div>
      </div>
    </div>
  </div>
  <bd-hr *ngIf="alternativeMode" class="alternative-divider">Vergleichbare Brother Produkte:</bd-hr>
  <div class="results">
    <bdcp-product-result *ngFor="let product of products"
                         [product]="product"
                         [isBrotherProduct]="isBrotherResult"
                         class="product">
    </bdcp-product-result>
    <div *ngFor="let pseudoProduct of pseudoProducts" class="product"></div>
  </div>
</div>
